$(document).ready(function () {
  $(".testimonial-slider").each(function(){
    let isLoop = false;
    let cellAlign = "left";
    let groupCells = true;
    if($(this).attr('data-loop') == 'true'){
      isLoop = true;
    }
    if($(this).attr('data-align') == 'center'){
      cellAlign = "center";
    }
    if($(this).attr('data-group')){
      groupCells = 1;
    }
    $(".testimonial-slider").flickity({
      // options
      cellAlign: cellAlign,
      contain: true,
      groupCells: groupCells,
      pageDots: false,
      imagesLoaded: true,
      wrapAround: isLoop,
    });

    if($(this).attr('data-arc') == 'true'){
      var $carousel = $(this);
      var flkty = $carousel.data('flickity');

      function applyArcEffect() {
        var $cells = $carousel.find('.testimonial-item-inner');
        var selectedIndex = flkty.selectedIndex;
        var cellCount = $cells.length;

        $cells.each(function (i) {
          var indexDiff = i - selectedIndex;

          // Handle wrap-around
          if (indexDiff > cellCount / 2) indexDiff -= cellCount;
          if (indexDiff < -cellCount / 2) indexDiff += cellCount;

          var angle = indexDiff * 4; // degrees, adjust for tighter/wider arc
          var scale = 1 - Math.abs(indexDiff) * 0.05;
          var translateY = indexDiff * 5; // adjust for vertical spacing
          var translateX = 5 * Math.pow(Math.abs(indexDiff), 2.585); // adjust for horizontal spacing
          var opacity = 1 - Math.abs(indexDiff) * 0.1;
          var transformOrigin;
          if(indexDiff > 0){
            transformOrigin = 'top left';
          }else{
            transformOrigin = 'top right';
          }

          $(this).css({
            transform: `rotate(${angle}deg) translate(${translateY}%,${translateX}%)`,
            transformOrigin: transformOrigin,
            opacity: opacity
          });
        });
      }

      $carousel.on('select.flickity', function () {
        applyArcEffect();
      });

      applyArcEffect();
    }

  })
  $(".lp-slider").flickity({
    // options
    cellAlign: "left",
    contain: true,
    groupCells: true,
    pageDots: true,
    imagesLoaded: true,
  });
  $(".lp-slider-v2").flickity({
    // options
    cellAlign: "left",
    contain: true,
    groupCells: true,
    pageDots: false,
    imagesLoaded: true,
    on:{
      ready: function(){
        //find all .slider-text inside this slider, match the height and apply it to all
        var slider = this;
        let textHeight = 0;
        $(slider).find('.slider-text').each(function(){
          if($(this).outerHeight() > textHeight){
            textHeight = $(this).outerHeight();
          }
        });
        $(slider).find('.slider-text').css('height', textHeight);
      }
    }
  });

  $(".main-image-gallery").each(function (index, element) {
    const thumbsElement = $(this).siblings(".thumbs-image-gallery");
    const mainElement = $(this);
    const mainCarousel = mainElement.flickity({
      sync: thumbsElement[0],
      cellAlign: "left",
      contain: true,
      groupCells: true,
      prevNextButtons: false,
      pageDots: false,
    });
    const thumbCarousel = thumbsElement.flickity({
      sync: mainElement[0],
      cellAlign: "left",
      contain: true,
      prevNextButtons: false,
      pageDots: false,
    });
    mainCarousel
      .siblings(".thumbs-image-gallery")
      .find(".thumbs-image-item")
      .on("click", function (event) {
        var clickedIndex = $(this).index();
        thumbCarousel.flickity("select", clickedIndex);
      });
  });

  $(document).on("click", ".accordion-header", function (event) {
    const parent = $(this).parent();
    parent.toggleClass("active");
    if (parent.hasClass("active")) {
      const contentHeight = parent.find(".content-wrapper").outerHeight();
      parent.find(".accordion-content").css("height", contentHeight + 15);
    } else {
      parent.find(".accordion-content").css("height", 0);
    }
  });

  const $lpProducts = $(".landing-featured-product");

  function createAvailableOptionsTree(
    variant_data,
    selected_options,
    currentVariant
  ) {
    return variant_data.reduce(
      (options, variant) => {
        Object.keys(options).forEach((index) => {
          if (variant[index] === null) return;

          let entry = options[index].find(
            (option) => option.value === variant[index]
          );
          if (typeof entry === "undefined") {
            entry = {
              value: variant[index],
              isUnavailable: true,
            };
            options[index].push(entry);
          }

          const countVariantOptionsThatMatchCurrent = selected_options.reduce(
            (count, { value, index }) => {
              return variant[index] === value ? count + 1 : count;
            },
            0
          );

          if (
            countVariantOptionsThatMatchCurrent >=
            selected_options.length - 1
          ) {
            entry.isUnavailable =
              entry.isUnavailable && variant.available
                ? false
                : entry.isUnavailable;
          }

          if (
            (!currentVariant || !currentVariant.available) &&
            selected_options.find(
              (option) => option.value === entry.value && index === option.index
            )
          ) {
            entry.isUnavailable = true;
          }

          if (index === "option1") {
            entry.isUnavailable =
              entry.isUnavailable && variant.available
                ? false
                : entry.isUnavailable;
          }
        });

        return options;
      },
      {
        option1: [],
        option2: [],
        option3: [],
      }
    );
  }

  function setDisabledClass($lpProduct) {
    const variantJson = $lpProduct.find(".variants-data").text();
    const variant_data = JSON.parse(variantJson);
    const $fieldsets = $lpProduct.find("fieldset");

    if (variant_data) {
      let selected_options;
      let currentVariant = variant_data[0];

      let variantTitle = "";
      let i = 0;
      $fieldsets.each(function () {
        i++;
        if (i > 1) {
          variantTitle += " / ";
        }
        let val = "";
        if ($(this).find("select").length) {
          val = $(this).find("select").val();
        } else {
          val = $(this).find("input:checked").val();
        }
        variantTitle += val;
      });

      currentVariant = variant_data.filter((variant_selected) => {
        return variant_selected.title === variantTitle;
      })[0];

      if (!currentVariant) {
        if ($fieldsets.eq(0).find("select").length) {
          const value1 = $fieldsets.eq(0).find("select").val();
          currentVariant = variant_data.filter((variant_selected) => {
            return variant_selected.option1 === value1;
          })[0];

          const selected_option2 = currentVariant.option2;
          if (
            selected_option2 &&
            $lpProduct.find(
              `.variant-container input[value='${selected_option2}']`
            ).length
          ) {
            $lpProduct
              .find(`.variant-container input[value='${selected_option2}']`)
              .trigger("click");
          }
        } else {
          const value1 = $fieldsets.eq(0).find("input:checked").val();
          currentVariant = variant_data.filter((variant_selected) => {
            return variant_selected.option1 === value1;
          })[0];

          const selected_option2 = currentVariant.option2;
          if (
            selected_option2 &&
            $lpProduct.find(
              `.variant-container input[value='${selected_option2}']`
            ).length
          ) {
            $lpProduct
              .find(`.variant-container input[value='${selected_option2}']`)
              .trigger("click");
          }
        }
      }

      selected_options = currentVariant.options.map((value, index) => {
        return {
          value,
          index: `option${index + 1}`,
        };
      });

      const available_options = createAvailableOptionsTree(
        variant_data,
        selected_options,
        currentVariant
      );

      currentVariant.options.forEach((value, index) => {
        const $fieldset = $fieldsets.eq(index);
        const fieldset_label = $fieldset.find(".form__label__value");
        fieldset_label.text(value);
      });

      $fieldsets.each((i, fieldset) => {
        if(i > 0){
          const fieldset_options = Object.values(available_options)[i];
          const $fieldset = $(fieldset);
  
          if (fieldset_options) {
            if ($fieldset.find("select").length) {
              fieldset_options.forEach((option) => {
                const $option = $fieldset.find(`option[value='${option.value}']`);
                //$option.prop("disabled", option.isUnavailable);
              });
            } else if ($fieldset.find("input").length) {
              $fieldset.find("input").each((input_i, input) => {
                const $input = $(input);
                $input.toggleClass(
                  "is-disabled",
                  fieldset_options[input_i].isUnavailable
                );
                $input.toggleClass(
                  "eam-is-hidden",
                  fieldset_options[input_i].isUnavailable
                );
              });
            }
          }
        }
      });

      if (currentVariant) {
        const featuredImage = currentVariant.featured_image.id;
        const mainImage = $lpProduct.find(".main-image-gallery");
        const imageElement = mainImage.find(`[data-id="${featuredImage}"]`);
        const imageIndex = imageElement.parent().children().index(imageElement);
        const mainFlickity = Flickity.data(mainImage[0]);
        mainFlickity.select(imageIndex);
      }

      //Price changes
      const priceElement = $lpProduct.find(".lp-product-price");
      const discountAmount = parseFloat(priceElement.attr("data-discount"));
      const discountType = priceElement.attr("data-discount-type");
      const priceCompare = priceElement.find(".price-compare");
      const priceFinal = priceElement.find(".price-final");
      const priceSavings = priceElement.find(".price-savings");

      let comparePrice, finalPrice, savings;
      if (currentVariant.compare_at_price > currentVariant.price) {
        comparePrice = currentVariant.compare_at_price;
        finalPrice = Math.ceil(currentVariant.price);
        savings = comparePrice - finalPrice;
      } else if (discountAmount) {
        comparePrice = currentVariant.price;
        finalPrice =
          discountType === "percentage"
            ? currentVariant.price * (1 - discountAmount / 100)
            : currentVariant.price - discountAmount * 100;
        finalPrice = Math.ceil(finalPrice);
        savings = comparePrice - finalPrice;
      } else {
        finalPrice = currentVariant.price;
      }
      const money_format =
        window.theme.settings.money_with_currency_format || "${{amount}}";
      if (comparePrice) {
        const comparePriceFormatted = window.formatMoney(
          comparePrice,
          money_format
        );
        priceCompare.html(comparePriceFormatted);
      }
      if (savings) {
        const savingsFormatted = window.formatMoney(savings, money_format);
        priceSavings.html(savingsFormatted).removeClass("hidden");
      } else {
        priceSavings.addClass("hidden");
      }
      const finalPriceFormatted = window.formatMoney(finalPrice, money_format);
      priceFinal.html(finalPriceFormatted);

      const atcButton = $lpProduct.find(".lp-product-atc a");
      const discountCode = $lpProduct.find("form").attr("data-code");
      if (currentVariant.available) {
        atcButton.removeClass("is-disabled").removeAttr("disabled");
        atcButton.text("Buy now");
        if (discountCode) {
          atcButton.attr(
            "href",
            "/cart/" + currentVariant.id + ":1?discount=" + discountCode
          );
        } else if (atcButton.length) {
          atcButton.attr("href", "/cart/" + currentVariant.id + ":1");
        }
      } else {
        atcButton.attr("href", "javascript:void(0);");
        atcButton.addClass("is-disabled").attr("disabled", "disabled");
        atcButton.text("Sold Out");
      }
    }
  }

  $lpProducts.each((_, lpProduct) => {
    if(!$(lpProduct).hasClass('v3')){
      setDisabledClass($(lpProduct));
    }
  });

  $(".lp-variant-picker input,.lp-variant-picker select").on(
    "change",
    function () {
      const lpProduct = $(this).parents(".landing-featured-product");
      setDisabledClass(lpProduct);
    }
  );

  $(document).on("click", ".lp-hamburger-menu", function (event) {
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      const mobileMenu = $(this)
        .parent()
        .next()
        .find(".menu-grid")
        .outerHeight();
      $(this).parent().next().css("height", mobileMenu);
    } else {
      $(this).parent().next().css("height", 0);
    }
  });
});
